// Enable tourguide.js (https://tourguidejs.com/)
const tourEl = document.getElementById('tour')
if (tourEl) {
    import("@sjmc11/tourguidejs").then(async (module) => {
        const data = JSON.parse(tourEl.textContent);

        const group = data.code;
        const steps = data.content?.map(step => ({
            ...step,
                "group": group,
            beforeEnter: async (currentStep, nextStep) => {
                if (nextStep.wider) {
                    await tg.setOptions({
                        dialogWidth: 1200,
                    });
                } else {
                    await tg.setOptions({
                        dialogWidth: 380,
                    });
                }
                tg.refreshDialog();
            }
        }))

        const tg = new module.TourGuideClient({
            completeOnFinish: true,
            dialogZ: 1100,
            backdropClass: "z-index-toast",
            exitOnClickOutside: false,
            steps,
            dialogMaxWidth: window.innerWidth
        })

        tg.onAfterExit(() => {
            const video = document.querySelector('.tg-dialog video')
            if (video)
                video.pause()
        })

        const startTourButton = document.getElementById('tourButton')
        if (startTourButton && steps) {
            startTourButton.addEventListener('click', e => {
                e.preventDefault();
                tg.start(group)
            })
        }

        if (!tg.isFinished(group)) {
            await tg.start(group)
        }
    });
}
